export const APPLY_CAMPAIGN_COLUMNS = 'APPLY_CAMPAIGN_COLUMNS'
